import { NAME } from './constants';

export const LOAD = `${NAME}/LOAD`;
export const CREATE = `${NAME}/CREATE`;
export const INIT = `${NAME}/INIT`;
export const REFRESH_ADDRESSES = `${NAME}/REFRESH_ADDRESSES`;
export const REMOVE_ADDRESS = `${NAME}/REMOVE_ADDRESS`;
